import { useAppContext } from "src/contexts/AppContext";
import fetchVocation from "src/features/vocations/services/fetchVocation";
import queryKeys from "src/lib/queryKeys";
import { Vocation, VocationId } from "src/types/Vocation";
import useAppQuery, { AppQueryResult } from "./useAppQuery";

const TWENTY_FOUR_HOURS = 1000 * 60 * 60 * 24;

export default function useVocation(
  vocationId: VocationId | undefined
): AppQueryResult<Vocation | null> {
  const { clients } = useAppContext();

  return useAppQuery<Vocation | null>({
    queryKey: queryKeys.vocation(vocationId),
    queryFn: () =>
      vocationId === undefined
        ? Promise.resolve(null)
        : fetchVocation(vocationId, clients),
    enabled: vocationId !== undefined,
    staleTime: TWENTY_FOUR_HOURS,
  });
}
